import { render, staticRenderFns } from "./TimeToLogout.vue?vue&type=template&id=a79dab18&scoped=true&"
import script from "./TimeToLogout.vue?vue&type=script&lang=js&"
export * from "./TimeToLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79dab18",
  null
  
)

export default component.exports